//defs
import { Value } from 'shared/components/Filter/types';

const characterRegexp = new RegExp(/\d/);

const transformObjectToArray = (bucketData: Record<string, Value[]>) => {
  return Object.keys(bucketData).map((value) => ({
    letterHeading: value,
    values: bucketData[value],
  }));
};

export const getFilteredValuesAndAlphabets = (
  showAlphabetHeading: boolean,
  values: Value[],
  searchText: string
) => {
  if (__SERVER__)
    return {
      filterValues: {},
      availableAlphabets: [],
    };

  if (!showAlphabetHeading)
    return {
      filterValues: values.filter((value) =>
        value.name.toLowerCase().includes(searchText.toLowerCase())
      ),
      availableAlphabets: [],
    };

  const bucket: Record<string, Value[]> = {};
  values.forEach((value) => {
    if (!value.name.toLowerCase().includes(searchText.toLowerCase())) return;
    const firstCharacter = characterRegexp.test(value.name.toUpperCase()[0])
      ? '#'
      : value.name.toUpperCase()[0];

    if (!bucket[firstCharacter]) {
      bucket[firstCharacter] = [];
    }
    bucket[firstCharacter].push(value);

    return bucket;
  });

  return {
    filterValues: transformObjectToArray(bucket),
    availableAlphabets: Object.keys(bucket),
  };
};
